module.exports = __webpack_public_path__ + "d.no1.f2c16f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/d.no1.jpg
// module id = 0RE7
// module chunks = 0